<mat-form-field appearance="outline">
    <mat-label>{{selectTitle}}</mat-label>
    <mat-select id="selectsearchid" data-testid="selectsearchid" [(ngModel)]="selectId" [disabled]="disabled"
        (selectionChange)="onSelectChange($event)" (blur)="onTouched()" [required]="isrequired"
        (openedChange)="onDropdownOpenChange($event)"
        [errorStateMatcher]="effectiveMatcher">
        <mat-option >
            <ngx-mat-select-search placeholderLabel="Search {{selectTitle}}..."    (input)="onSearch($event)"
                noEntriesFoundLabel="no matching status found"></ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">-Select {{selectTitle}}-</mat-option>
        @for (item of filteredSelectList; track item.id + '-' + $index) {
            <mat-option [value]="item.id" [disabled]="item.disabled === true" [ngClass]="item.itemCssClass || ''">
                {{ item.name }}
            </mat-option>
        }
    </mat-select>
    @if (invalid) {
        <mat-error>{{selectTitle}} is required</mat-error>
    }
</mat-form-field>